import { memo } from 'react';
import Button from '../Button.jsx';
import ModalLayout from '../ModalLayout.jsx';

const DocumentDeleteConfirmModal = ({
  isOpen = false,
  documentTitle = '',
  onCancel,
  onConfirm,
}) => {
  return (
    <ModalLayout
      isOpen={isOpen}
      onClose={onCancel}
      useBodyPortal
      title=""
      closeAriaLabel="Close delete confirmation"
      maxWidthClassName="max-w-[960px]"
      heightClassName="h-auto max-h-[90vh]"
      panelClassName="min-h-[220px] min-w-[280px] rounded-lg"
    >
      <div className="flex min-h-0 flex-1 flex-col items-center px-6 pb-8 pt-6 text-center">
        <p className="text-3xl font-semibold text-content">
          {`Are you sure you want to delete "${documentTitle || 'this document'}"?`}
        </p>
        <p className="mt-6 text-lg text-content-secondary">This action cannot be undone.</p>
        <div className="mt-9 flex items-center justify-center gap-4">
          <Button variant="secondary" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="primary" onClick={onConfirm}>
            Delete
          </Button>
        </div>
      </div>
    </ModalLayout>
  );
};

export default memo(DocumentDeleteConfirmModal);
